import { apiGet, apiPost, apiPut, apiDelete, useApi } from './client'
import type { ApiResponse } from '@crm/shared'
import { useAuthStore } from '../stores/auth.store'

export interface QueryRow {
  id: string
  tenant_id: string
  object_id: string
  name: string
  filters: string | null
  sort_by: string | null
  columns: string | null
  visibility: 'all_roles' | 'specific_roles'
  created_by: string
  is_default: number
  created_at: string
}

export function useObjectQueries(objectId: string | null) {
  const token = useAuthStore((state) => state.token)
  const path = objectId && token ? `/objects/${objectId}/queries` : null
  return useApi<ApiResponse<QueryRow[]>>(path)
}

export async function fetchQueries(objectId: string): Promise<ApiResponse<QueryRow[]>> {
  return apiGet<ApiResponse<QueryRow[]>>(`/objects/${objectId}/queries`)
}

export async function createQuery(
  objectId: string,
  data: {
    name: string
    filters?: unknown
    sort_by?: unknown
    columns?: string[]
    visibility?: 'all_roles' | 'specific_roles'
    is_default?: boolean
  },
) {
  return apiPost<ApiResponse<QueryRow>, typeof data>(`/objects/${objectId}/queries`, data)
}

export async function updateQuery(
  objectId: string,
  queryId: string,
  data: {
    name?: string
    filters?: unknown
    sort_by?: unknown
    columns?: string[]
    visibility?: 'all_roles' | 'specific_roles'
    is_default?: boolean
  },
) {
  return apiPut<ApiResponse<QueryRow>, typeof data>(`/objects/${objectId}/queries/${queryId}`, data)
}

export async function deleteQuery(objectId: string, queryId: string) {
  return apiDelete<ApiResponse<{ success: boolean }>>(`/objects/${objectId}/queries/${queryId}`)
}

export async function updateQueryRoles(objectId: string, queryId: string, roleIds: string[]) {
  return apiPut<ApiResponse<{ success: boolean }>, { role_ids: string[] }>(
    `/objects/${objectId}/queries/${queryId}/roles`,
    { role_ids: roleIds },
  )
}
